import { useSubscriber } from 'app/socketConnection';
import { LockActionData } from 'entities/Box/model/types';

export const useOnBoxUnauthorizedAccess = (): Nullable<LockActionData> => useSubscriber<LockActionData>('boxUnauthorizedAccess');
